<nav class="nav-container">
  <div class="logo mpo">
    <img [src]="currentOrganizationLogo" alt="MPO" height="55" />
  </div>
  <div class="hamburger-menu" (click)="toggleMobileMenu()">
    <img src="/assets/icons/list.svg" alt="Menu" />
  </div>
  <div class="nav-links" [class.mobile-open]="isMobileMenuOpen">
    <a *ngIf="showReport" routerLink="/reports" routerLinkActive="active">Reports</a>
    <a *ngIf="showSearchAndAssign" routerLink="/search" routerLinkActive="active">Search & Assign</a>
    <a *ngIf="showDispute" routerLink="/disputes" routerLinkActive="active">
      Disputes
    </a>

    <!-- <a *ngIf="showFinance" routerLink="/old-finance" routerLinkActive="active">Finance</a> -->
    <a *ngIf="showNewFinance" routerLink="/finance" routerLinkActive="active">Finance</a>
    <!-- <a *ngIf="showDistributions" routerLink="/old-distributions" routerLinkActive="active">Distributions</a> -->
    <a *ngIf="showDataMerge" routerLink="/datatool" routerLinkActive="active">Data Merge</a>
    <a *ngIf="showAuditDashboard" routerLink="/audit" routerLinkActive="active">Audit</a>
    <a *ngIf="showCacheSync" routerLink="/admin/redis-sync" routerLinkActive="active">Cache Sync</a>
    <a *ngIf="showDistributions" routerLink="/distributions" routerLinkActive="active">Distributions</a>
  </div>
  <div class="info dropdown" [class.show]="isDropdownOpen" (click)="toggleDropdown(); $event.stopPropagation()">
      <div class="names">
        <div class="label">{{displayLabel}}</div>
        <div class="user">{{Name}}</div>
      </div>
      <div class="images">
        <img *ngIf="currentUser.user.hasImage" class="avatar" [src]="currentUserImage" (error)="onAvatarError($event)" />
        <img class="chevron" src="/assets/icons/chevron-down.svg" />
      </div>

    <div class="dropdown-content" *ngIf="isDropdownOpen">
      <a class="h">Access & Labels</a>
      <a *ngIf="showSwitchLabel" (click)="openSwitchLabelModal(); $event.stopPropagation()">Switch label
          <figure class="shortcut">
             <!-- <span>⌥</span><span>⇧</span><span>L</span> -->
          </figure>
      </a>

      <a *ngIf="showLabelManagement" routerLink="/labels" (click)="closeDropdown(); $event.stopPropagation()">Browse all labels</a>
      <a *ngIf="showAdminTools" [routerLink]="'/settings/' + currentUser.board.id" (click)="closeDropdown(); $event.stopPropagation()">User Management </a>
      <div class="separator" *ngIf="showLabelManagement || showUserManagement"></div>
      <a class="h">Personal</a>
      <a routerLink="/profile-settings" (click)="closeDropdown(); $event.stopPropagation()">Profile settings</a>
      <a (click)="logout(); closeDropdown(); $event.stopPropagation()">Sign out</a>
    </div>
  </div>
</nav>

 <div class="modal" id="switchLabel" [class.show]="isSwitchLabelModalOpen" (click)="closeSwitchLabelModal()">
      <div class="mw labelswitch" (click)="$event.stopPropagation()">
        <div class="mwrap">
          <div class="mc">
            <input
              #labelSearchInput
              id="quick-label-search"
              class="search"
              type="search"
              placeholder="Find label..."
              autocomplete="off"
              autofocus
              [(ngModel)]="searchQuery"
              (input)="onSearchChange()"
            />

            <!-- INITIAL EMPTY STATE + NO RESULT-->
            <div class="message" [class.visible]="showInitialMessage" [class.hidden]="!showInitialMessage" id="initial-message">
              <p><b>Start typing</b> to find <b>your</b> labels...</p>
            </div>
            <div class="message" [class.visible]="showNoResultMessage" [class.hidden]="!showNoResultMessage" id="no-result-message">
              <p><b>No result found</b></p>
            </div>

            <hr class="dashed" id="dashed-line"  *ngIf="!showNoResultMessage"/>

            <div id="search-results" [class.visible]="showSearchResults" [class.hidden]="!showSearchResults">
                <button class="btn white visible" *ngFor="let result of searchResults" (click)="switchLabel(result.boardId)"><p>{{result.name}}</p><img data-attribute="hoverarrow" src="/assets/icons/arrow-right.svg" alt="Go to label"></button>
            </div>

            <button class="btn green" [class.visible]="showViewAllButton" [class.hidden]="!showViewAllButton" id="view-all-labels" routerLink="/labels" (click)="closeSwitchLabelModal()">
              View all labels
            </button>
          </div>
        </div>
      </div>
    </div>
